export const paymentScreensConfig = {
  screensImg: {
    acceptedList: ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
    maxSize: 5 * 1024 * 1024, // in bytes

    // maxWidth: 1920,
    // maxHeight: 1080,

    maxLengthFileName: 100,

    accept: {
      'image/png': [],
      'image/jpeg': [],
      'image/jpg': [],
      'image/webp': [],
    },
  },
}
